import { createAsyncThunk } from "@reduxjs/toolkit";
import { Shape } from "../../../client/services";
import { toastHandler } from "../../../utils/toastHandler";
import { FindShape, GetShape } from "../../shape/api/interface";

export const findSelectShape = createAsyncThunk(
  "selectShape/findSelectShape",
  async (values: FindShape, { rejectWithValue }) => {
    try {
      const response = await Shape.find({
        query: values,
      });
      return response;
    } catch (error: any) {
      toastHandler(error);
      return rejectWithValue(error.message);
    }
  }
);

export const searchSelectShape = createAsyncThunk(
  "selectShape/searchSelectShape",
  async (values: FindShape, { rejectWithValue }) => {
    try {
      const response = await Shape.find({
        query: values,
      });
      return response;
    } catch (error: any) {
      toastHandler(error);
      return rejectWithValue(error.message);
    }
  }
);


export const getSelectShape = createAsyncThunk(
  'selectShape/getSelectShape',
  async ({ id }: GetShape, { rejectWithValue }) => {
    try {
      const response = await Shape.get(id);

      return response;
    } catch (error: any) {
      toastHandler(error);
      return rejectWithValue(error.message);
    }
  }
);
